import { legalApi } from '../api/legal';
import { useAuthStore } from '../stores/authStore';

export async function checkLegalStatus() {
  try {
    const status = await legalApi.getStatus();
    const store = useAuthStore.getState();
    if (status.is_managed_sub_user) {
      store.setSubUserBlocked(status.blocked_by_guardian);
      store.setNeedsLegalAgreements(false);
    } else {
      store.setSubUserBlocked(false);
      store.setNeedsLegalAgreements(!status.allowed && status.outstanding.length > 0);
    }
  } catch (err) {
    console.error('Failed to check legal status:', err);
  }
}
